// @flow

import { BODY_ID, Detection } from 'Constants';
import { OVERLAY_CALLER_ID as NAV_OVERLAY } from 'contexts/nav-context';

let cachedY: number = 0;
let bodyRef: HTMLElement;
let overlayCaller: string = '';

export const initFullscreenOverlay = (caller: string) => {
  if (!bodyRef) bodyRef = document.getElementById(BODY_ID);
  cachedY = window.scrollY || window.pageYOffset;
  toggleLock(true);
  if (bodyRef) bodyRef.style.transform = `translateY(-${cachedY}px)`;
  if (!overlayCaller) overlayCaller = caller;
};

export const closeFullscreenOverlay = (caller: string, pageToTop = false) => {
  if (overlayCaller === caller || overlayCaller === NAV_OVERLAY) {
    if (!bodyRef) bodyRef = document.getElementById(BODY_ID);
    toggleLock(false);
    if (bodyRef) bodyRef.style.transform = 'unset';
    if (pageToTop) {
      cachedY = 0;
    } else if (cachedY !== 0) {
      setTimeout(() => {
        window.scrollTo(0, cachedY);
        cachedY = 0;
      }, 1);
    }
    overlayCaller = '';
  }
};

export const toggleLock = (lock: boolean) => {
  if (Detection.IS_BROWSER) {
    const { body, documentElement } = document;
    body.style.overflowY = lock ? 'hidden' : '';
    body.style.height = lock ? '100%' : '';
    body.style.width = lock ? '100%' : '';
    body.style.position = lock ? 'fixed' : '';
    documentElement.style.overflowY = lock ? 'hidden' : '';
    documentElement.style.height = lock ? '100%' : '';
    documentElement.style.position = lock ? 'fixed' : '';
    documentElement.style.width = lock ? '100%' : '';
  }
};
